var _path, _path2, _path3, _g, _circle, _path4, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWatch = function SvgWatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 80,
    viewBox: "0 0 134 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 12C16 9.79086 17.7909 8 20 8H114C116.209 8 118 9.79086 118 12V68C118 70.2091 116.209 72 114 72H20C17.7909 72 16 70.2091 16 68V12Z",
    fill: "url(#watch_svg__paint0_linear_9773_32890)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118 68C118 70.2091 116.209 72 114 72L20 72C17.7909 72 16 70.2091 16 68L118 68Z",
    fill: "#D6D6D6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "watch_svg__mask0_9773_32890",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 68,
    width: 28,
    height: 4
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 72L19.9423 72C17.9225 72 16.2852 70.3626 16.2852 68.3429L44 68.3429L44 72Z",
    fill: "#ABABAB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#watch_svg__mask0_9773_32890)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#watch_svg__filter0_f_9773_32890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.36894 67.5345C-0.692309 67.9983 -1.63961 70.9447 1.01636 74.4392C2.50827 76.3729 5.4734 76.6835 14.2158 76.6071C34.3228 76.4214 54.6006 76.4222 74.836 76.369C78.3337 76.3581 80.7245 75.78 80.1742 75.0782C79.0892 73.6945 78.0038 72.3105 76.9194 70.9264C72.4347 65.2019 62.5475 60.7764 55.8952 61.5361L3.36894 67.5345Z",
    fill: "#FFB9F8"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#watch_svg__filter1_f_9773_32890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1616 86.628C23.1603 86.6284 23.1585 86.6273 23.1596 86.6267C29.651 82.6501 38.7972 78.0355 49.6234 73.3301C50.5091 72.9454 51.4043 72.5609 52.3074 72.1764C54.3111 71.3235 54.5205 69.5619 52.7441 68.1653C50.7251 66.5779 47.0684 66.167 45.01 67.2822L20.2567 80.6935C18.7193 81.5264 18.6865 83.0183 20.1689 84.2133C21.1666 85.0176 22.1623 85.8227 23.1618 86.6269C23.1623 86.6273 23.1622 86.6278 23.1616 86.628Z",
    fill: "#FFE665"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#watch_svg__filter2_f_9773_32890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5056 68.4673L16.2871 72.4583H20.206L26.5803 70.2088L27.877 68.4673L26.5803 67.8868L24.5056 68.4673Z",
    fill: "#0A9F68"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#watch_svg__filter3_f_9773_32890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4.22304 81.0813C7.75156 75.9463 23.6976 69.5618 41.8615 62.657C44.5993 61.6165 47.3773 60.5681 50.1845 59.5135C51.3734 59.0668 51.5367 58.056 50.5099 57.2553C49.4798 56.4521 47.6832 56.2013 46.5256 56.6765L-5.39866 77.9933C-6.3284 78.375 -6.43117 79.1891 -5.64967 79.8509C-5.17293 80.2546 -4.69861 80.6592 -4.21954 81.0623C-4.21138 81.0692 -4.21294 81.0776 -4.22304 81.0813Z",
    fill: "#71BBFF"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66.8286,
    cy: 40.0004,
    r: 17.0786,
    stroke: "#FAFAFA",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "watch_svg__mask1_9773_32890",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 29,
    width: 15,
    height: 22
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6682 38.4554C76.6396 39.2554 76.6396 40.7431 75.6682 41.5431L65.2714 50.1051C63.9667 51.1796 62 50.2515 62 48.5613L62 31.4372C62 29.747 63.9667 28.8188 65.2714 29.8933L75.6682 38.4554Z",
    fill: "#E9E8E8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#watch_svg__mask1_9773_32890)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#watch_svg__filter4_f_9773_32890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.1107 32.3813C48.1541 33.6292 45.9705 38.1701 47.8018 43.3775C48.1911 44.4845 48.5777 45.5914 48.9593 46.6984C50.3128 50.566 53.0028 51.1871 60.9338 51.0342C79.1749 50.6629 97.5709 50.6645 115.928 50.5581C119.101 50.5363 121.27 49.38 120.771 47.9764C118.925 42.7866 117.078 37.5941 115.237 32.4018C112.641 25.0782 103.44 19.7104 96.4689 21.4654L53.1107 32.3813Z",
    fill: "#FFB9F8"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#watch_svg__filter5_f_9773_32890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.343 54.2518C47.3411 54.2518 47.3415 54.2493 47.3434 54.2489C57.5282 52.2181 70.4105 50.7923 84.5344 50.204C85.3618 50.1699 86.1922 50.1387 87.0254 50.11C90.1803 50.0013 93.3338 47.639 94.2143 44.6679C95.2531 41.1627 92.6925 38.439 88.9036 38.9826L55.0988 43.8325C52.3318 44.2295 49.7768 46.3615 48.9884 48.9202C48.4411 50.6967 47.8911 52.4731 47.345 54.2504C47.3447 54.2512 47.3438 54.2519 47.343 54.2518Z",
    fill: "#FFE665"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#watch_svg__filter6_f_9773_32890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5522 84.213C32.4155 73.943 46.8818 61.1742 63.36 47.3645C65.6511 45.445 67.9732 43.5119 70.3184 41.5681C71.7275 40.4003 72.1521 38.1896 71.2375 36.6156C70.2952 34.994 68.3294 34.7356 66.9213 36.01L20.9597 77.6081C19.8455 78.6165 19.5398 80.4118 20.2446 81.7274C20.6827 82.5452 21.1185 83.3648 21.5587 84.1814C21.5643 84.1917 21.5614 84.2058 21.5522 84.213Z",
    fill: "#71BBFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "watch_svg__filter0_f_9773_32890",
    x: -8.47729,
    y: 53.451,
    width: 96.7302,
    height: 31.1664,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_9773_32890"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "watch_svg__filter1_f_9773_32890",
    x: 11.0798,
    y: 58.6527,
    width: 50.8738,
    height: 35.9753,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_9773_32890"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "watch_svg__filter2_f_9773_32890",
    x: 12.2871,
    y: 63.8868,
    width: 19.5898,
    height: 12.5714,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_9773_32890"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "watch_svg__filter3_f_9773_32890",
    x: -14.1729,
    y: 48.4368,
    width: 73.3611,
    height: 40.6445,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_9773_32890"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "watch_svg__filter4_f_9773_32890",
    x: 39.1597,
    y: 13.1307,
    width: 89.6831,
    height: 45.9242,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_9773_32890"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "watch_svg__filter5_f_9773_32890",
    x: 39.3418,
    y: 30.9133,
    width: 63.105,
    height: 31.3385,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_9773_32890"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "watch_svg__filter6_f_9773_32890",
    x: 11.8669,
    y: 27.2028,
    width: 67.8542,
    height: 65.0103,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_9773_32890"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "watch_svg__paint0_linear_9773_32890",
    x1: 32.575,
    y1: 8,
    x2: 77.1531,
    y2: 69.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E8E8"
  })))));
};
export default SvgWatch;